<div class="carousel">
  <header class="carousel__header l_flex">
    <dgx-flex-row-header
      class="l_flex-grow"
      [row]="row"
      [menuConfig]="menuConfig"
      [markdownDescription]="markdownDescription"
      [row]="row"
      [hideQuickEditHeader]="hideQuickEditHeader"
      [hideReorderButton]="hideReorderButton"
      [permanentEditMode]="isEditing"
      [useCarousels]="true"
    ></dgx-flex-row-header>

    <div class="l_flexbar l_flex-justify-right guts-m-b-1">
      <dgx-link-row
        [links]="links"
        *ngIf="!carouselLoading && links?.length > 0 && !hideLinks"
      ></dgx-link-row>

      <div class="guts-p-l-1">
        <button
          [attr.aria-label]="i18n.dgCarousel_ShowPreviousItems"
          class="
            carousel__button
            guts-p-v-quart guts-p-h-half
            m-guts-p-h-half
            guts-m-r-quart
            js-carousel-btn js-carousel-btn-left
          "
          dir="ltr"
          df-button
          dfButtonType="passive"
          [disabled]="isBeginningOfCarousel"
          (click)="swipeTo.emit(true)"
          data-dgat="carousel-1ad"
        >
          <df-icon icon="chevron-left"></df-icon>
        </button>
        <button
          [attr.aria-label]="i18n.dgCarousel_ShowNextItems"
          class="
            carousel__button
            guts-p-v-quart guts-p-h-half
            m-guts-p-h-half
            js-carousel-btn js-carousel-btn-right
          "
          dir="ltr"
          df-button
          dfButtonType="passive"
          [disabled]="isEndOfCarousel"
          (click)="swipeTo.emit()"
          data-dgat="carousel-3b9"
        >
          <df-icon icon="chevron-right"></df-icon>
        </button>
      </div>
    </div>
  </header>
</div>
